module.exports = __webpack_public_path__ + "img/4069c25adb80f3e6f614be3e43697f60.png";